import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromFaqCategories from '../reducers/faq-categories.reducer';
import { FaqItem } from '../../models';
import * as fromRoot from '../../../store';
import { getSelectedCollection } from 'src/app/shop';

export const getFaqCategoriesStateSelector = createSelector(
  fromFeature.getFaqCategoriesState,
  (state: fromFeature.FaqCategoriesState) => state.faqCategories
);

export const getFaqCategoriesEntities = createSelector(getFaqCategoriesStateSelector, fromFaqCategories.getFaqCategoriesEntities);

export const getAllFaqCategories = createSelector(getFaqCategoriesEntities, entities => {
  return Object.keys(entities).map(name => entities[name]);
});

export const getFaqCategoriesLoaded = createSelector(getFaqCategoriesStateSelector, fromFaqCategories.getFaqCategoriesLoaded);
export const getFaqCategoriesLoading = createSelector(getFaqCategoriesStateSelector, fromFaqCategories.getFaqCategoriesLoading);
export const getFaqCategoriesError = createSelector(getFaqCategoriesStateSelector, fromFaqCategories.getFaqCategoriesError);

export const getActiveCollectionFaqCategories = createSelector(
  getAllFaqCategories,
  getSelectedCollection,
  fromRoot.getRouterState,
  (categories, collection, router) => {
    // get last part of collection id, which is the actual id, the rest is just the type and maybe some other info
    const collectionId = collection?.id.split('/').pop();

    if (!collectionId) {
      return [];
    }
    return categories.filter(category => category.collections?.some(collection => collection.collectionId === collectionId));
  }
);

export const getActiveCollectionFaqs = createSelector(getActiveCollectionFaqCategories, categories => {
  // return all faqs from every category (FaqCategory[]), however every faq.category should be set to that category
  const faqs: FaqItem[] = [];
  categories.forEach(category => {
    category.faqs?.forEach(faq => {
      faqs.push({
        ...faq,
        category: { id: category.id, name: category.name, order: category.order },
      });
    });
  });
  return faqs;
});
